import { render } from "./UnsubscribeNotificationView.vue?vue&type=template&id=0052b95e"
import script from "./UnsubscribeNotificationView.vue?vue&type=script&lang=js"
export * from "./UnsubscribeNotificationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__